/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const teamMemberStatusEnum = {
  joined: 'joined',
  invited: 'invited',
  archived: 'archived',
} as const;

export type TeamMemberStatusEnumSchemaKey = (typeof teamMemberStatusEnum)[keyof typeof teamMemberStatusEnum];

export type TeamMemberStatusSchema = TeamMemberStatusEnumSchemaKey;
